module.exports = __webpack_public_path__ + "img/14-IP-reflect-on-the-interview-to-learn-and-grow.075778b8.svg";